const gradesDevices = new Swiper(".swiper-grades", {
  spaceBetween: 10,
  slidesPerView: 2.5,
  slideToClickedSlide: true,
  centeredSlides: true,
  breakpoints: {
    769: {
      slidesPerView: 4,
      allowTouchMove: false,
      touchRatio: 0,
    },
    990: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});
const gradesContent = new Swiper(".swiper-grades-content", {
  spaceBetween: 0,
  allowTouchMove: false,
  slidesPerView: 1,
});
gradesDevices.controller.control = gradesContent;

function handleGradingTouchPointClick(event) {
  const id = event.target.getAttribute("touch-point-id");
  const gradingGroup = event.target.closest(".device-content-block");
  const selectedTab = gradingGroup.querySelector(`#${id}`);
  const touchPointsTabs = gradingGroup.querySelectorAll(".touch-points-tab");
  const touchPoints = gradingGroup.querySelectorAll(".touch-point");

  // Handle touch points
  touchPoints.forEach(function (el) {
    el.classList.remove("active");
  });
  event.target.classList.add("active");

  // Handle images
  touchPointsTabs.forEach(function (el) {
    el.classList.remove("active");
  });
  selectedTab.classList.add("active");
}
